(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fx-hero-backdrop"] && !Shopify.designMode) return;
  try {
    (function () {
      if (window.__fxHeroParallaxInit) return;
      window.__fxHeroParallaxInit = true;

      var ticking = false;

      function applyParallax() {
        ticking = false;
        var elements = document.querySelectorAll('[data-fx-parallax]');
        if (!elements.length) return;

        var scrollY = window.scrollY || window.pageYOffset;

        elements.forEach(function (el) {
          var factor = parseFloat(el.getAttribute('data-fx-parallax')) || 0;
          el.style.transform = 'translateY(' + (scrollY * factor) + 'px)';
        });
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(applyParallax);
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      applyParallax();
    })();
  } catch(e) { console.error(e); }
})();

})();
